/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LexplusIndividuelleAnforderungVerlaufListResponseDto } from '../../models/lexplus-individuelle-anforderung-verlauf-list-response-dto';
import { LexplusVerlaufFilterEnum } from '../../models/lexplus-verlauf-filter-enum';

export interface IndividuelleAnforderungDetailControllerGetIndividuelleAnforderungVerlaufV1$Params {
  individuelleAnforderungID: string;
  filter?: LexplusVerlaufFilterEnum;
  page?: number;
  limit?: number;
}

export function individuelleAnforderungDetailControllerGetIndividuelleAnforderungVerlaufV1(http: HttpClient, rootUrl: string, params: IndividuelleAnforderungDetailControllerGetIndividuelleAnforderungVerlaufV1$Params, context?: HttpContext): Observable<StrictHttpResponse<LexplusIndividuelleAnforderungVerlaufListResponseDto>> {
  const rb = new RequestBuilder(rootUrl, individuelleAnforderungDetailControllerGetIndividuelleAnforderungVerlaufV1.PATH, 'get');
  if (params) {
    rb.path('individuelleAnforderungID', params.individuelleAnforderungID, {});
    rb.query('filter', params.filter, {});
    rb.query('page', params.page, {});
    rb.query('limit', params.limit, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LexplusIndividuelleAnforderungVerlaufListResponseDto>;
    })
  );
}

individuelleAnforderungDetailControllerGetIndividuelleAnforderungVerlaufV1.PATH = '/v1/compliance/firmeninterne-anforderungen/{individuelleAnforderungID}/verlauf';
